export enum UserActionHistory {
    SELECTED_HOME_TABS_INDEX = 'selectedHomeTabsIndex',
    HOME_TABS_VIEW = 'homeTabsView',
    HOME_TAB_OVERVIEW = 'homeTabsOverview',
    HOME_THIRD_COLUMN_TOGGLE = 'homeThirdColumnToggle',
}
